import React from "react"

const QrCodeIcon: React.FC = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6668 15V16.6667H15.0002M16.6668 11.6667H15.8335L14.1668 13.3334M13.3335 15H11.6668V16.6667M3.3335 3.33337H8.3335V8.33337H3.3335V3.33337ZM11.6668 3.33337H16.6668V8.33337H11.6668V3.33337ZM3.3335 11.6667H8.3335V16.6667H3.3335V11.6667ZM11.6668 11.6667V12.5H12.5002V11.6667H11.6668Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default QrCodeIcon
